import { render } from "./VPhoneField.vue?vue&type=template&id=46741dd2&ts=true"
import script from "./VPhoneField.vue?vue&type=script&lang=ts"
export * from "./VPhoneField.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../deps/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__